/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Visa_Eb3_Point_1_TextInputs */

const en_visa_eb3_point_1_text = /** @type {(inputs: Visa_Eb3_Point_1_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Many EB-3 cases depend on careful alignment between the offered role, recruitment history, and supporting documentation from the employer.`)
};

const pt_visa_eb3_point_1_text = /** @type {(inputs: Visa_Eb3_Point_1_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Muitos casos EB-3 dependem do alinhamento cuidadoso entre a função oferecida, histórico de recrutamento e documentação de apoio do empregador.`)
};

const es_visa_eb3_point_1_text = /** @type {(inputs: Visa_Eb3_Point_1_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Muchos casos EB-3 dependen de la alineación cuidadosa entre el puesto ofrecido, el historial de contratación y la documentación de respaldo del empleador.`)
};

/**
* | output |
* | --- |
* | "Many EB-3 cases depend on careful alignment between the offered role, recruitment history, and supporting documentation from the employer." |
*
* @param {Visa_Eb3_Point_1_TextInputs} inputs
* @param {{ locale?: "en" | "pt" | "es" }} options
* @returns {LocalizedString}
*/
export const visa_eb3_point_1_text = /** @type {((inputs?: Visa_Eb3_Point_1_TextInputs, options?: { locale?: "en" | "pt" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Visa_Eb3_Point_1_TextInputs, { locale?: "en" | "pt" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt") return pt_visa_eb3_point_1_text(inputs)
	if (locale === "es") return es_visa_eb3_point_1_text(inputs)
	return en_visa_eb3_point_1_text(inputs)
});